import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/home',
    component: Home,
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "form" */ '../views/Login.vue'),
  },
  {
    path: '/features',
    component: () => import(/* webpackChunkName: "features" */ '../views/Features'),
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "features-overview" */ '../views/features/FeaturesOverview'),
      },
      {
        path: 'collaboration',
        component: () => import(/* webpackChunkName: "features-collaboration" */ '../views/features/Collaboration'),
      },
      {
        path: 'theming',
        component: () => import(/* webpackChunkName: "features-theming" */ '../views/features/Theming'),
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "features-theming-overview" */ '../views/features/theming/ThemingOverview'),
          },
          {
            path: 'colors',
            component: () => import(/* webpackChunkName: "features-theming-colors" */ '../views/features/theming/ColorsTheming'),
          },
          {
            path: 'logos',
            component: () => import(/* webpackChunkName: "features-theming-logos" */ '../views/features/theming/LogosTheming'),
          },
        ],
      },
      {
        path: 'story-builder',
        component: () => import(/* webpackChunkName: "features-story-builder" */ '../views/features/StoryBuilder'),
      },
      {
        path: 'query-param-to-event',
        component: () => import(/* webpackChunkName: "features-query-param-to-event" */ '../views/features/QueryParamToEvent'),
      },
    ],
  },
  {
    path: '/about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About'),
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "about-overview" */ '../views/about/AboutOverview'),
      },
      {
        path: 'contact',
        component: () => import(/* webpackChunkName: "about-contact" */ '../views/about/Contact'),
      },
      {
        path: 'company',
        component: () => import(/* webpackChunkName: "about-company" */ '../views/about/Company'),
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "about-company-overview" */ '../views/about/Company'),
          },
          {
            path: 'our-history-that-spans-more-than-100-years-were-we-achieved-more-than-anyone-else',
            component: () => import(/* webpackChunkName: "about-company-long-link" */ '../views/about/Company'),
          },
        ],
      },
    ],
  },
  { path: '*', redirect: '/home' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
